import { useMemo } from 'react';
import { useMedia } from 'react-use';

import { breakpoints } from '@/shared/components';

export const useBreakpoints = () => {
  const xl = useMedia(breakpoints.xl);
  const lg = useMedia(breakpoints.lg);
  const md = useMedia(breakpoints.md);
  const sm = useMedia(breakpoints.sm);

  return useMemo(() => ({ xl, lg, md, sm }), [xl, lg, md, sm]);
};
